import decoder from "../utility/decoder";
const isTokenExpired = (navigate) => {
  const user = sessionStorage.getItem("user")
    ? decoder(sessionStorage.getItem("user"))
    : {};
  if (user?.data)
    if (user?.data?.exp < Date.now() / 1000) {      
      sessionStorage.removeItem("LastLogin");
      sessionStorage.removeItem("TenantName");
      sessionStorage.removeItem("accessRole");
      sessionStorage.removeItem("user");
      navigate("/login", { state: { data: "expired" } });
      return true;
    }
  return false;
};
export default isTokenExpired;
